import { BiHomeAlt, BiUser } from 'react-icons/bi';
import { BsGear, BsBriefcase, BsChatSquareText } from 'react-icons/bs';

const Nav = ({activeComp, handleClick}) => {
  return (
    <nav className='fixed bottom-2 lg:bottom-8 w-full overflow-hidden z-10'>
      <div className='container mx-auto'>
        <ul className='w-full bg-black/20 h-[80px] backdrop-blur-2x1 rounded-full max-w-[460px] mx-auto px-5 flex justify-between items-center text-2x1 text-white/50'>
          <li 
            id="home" 
            onClick={() => handleClick("home")}
            className={`cursor-pointer w-[60px] h-[60px] flex items-center justify-center ${activeComp === "home" ? 'active' : ""}`}
          >
            <BiHomeAlt />
          </li>
          <li 
            id="work" 
            onClick={() => handleClick("work")}
            className={`cursor-pointer w-[60px] h-[60px] flex items-center justify-center ${activeComp === "work" ? 'active' : ""}`}
          >
            <BsBriefcase />
          </li>
          <li 
            id="skills" 
            onClick={() => handleClick("skills")}
            className={`cursor-pointer w-[60px] h-[60px] flex items-center justify-center ${activeComp === "skills" ? 'active' : ""}`}
          >
            <BsGear />
          </li>
          <li 
            id="resume" 
            onClick={() => handleClick("resume")}
            className={`cursor-pointer w-[60px] h-[60px] flex items-center justify-center ${activeComp === "resume" ? 'active' : ""}`}
          >
            <BiUser />
          </li>
          <li 
            id="contact"
            onClick={() => handleClick("contact")}
            className={`cursor-pointer w-[60px] h-[60px] flex items-center justify-center ${activeComp === "contact" ? 'active' : ""}`}
          >
            <BsChatSquareText />
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Nav;